import {
	BoxComponentType,
	IBoxCheckboxListComponent,
	IBoxChooserComponent,
	IBoxComponent,
	IBoxFormComponent,
	IBoxInputComponent,
	IBoxRadioListComponent,
	IBoxSelectComponent,
	IBoxSubmitComponent,
} from '../types';

export const isBoxComponentFormElement = (
	field: IBoxComponent,
): field is IBoxComponent<IBoxFormComponent> =>
	[
		BoxComponentType.CHECKBOXLIST,
		BoxComponentType.RADIOLIST,
		BoxComponentType.CHOOSER,
		BoxComponentType.SELECT,
		BoxComponentType.INPUT,
		BoxComponentType.TEXTAREA,
		BoxComponentType.CHECKBOX,
		BoxComponentType.RATING,
	].includes(field.type);

export const isBoxComponentWithOptions = (
	field: IBoxComponent,
): field is IBoxComponent<
	| IBoxCheckboxListComponent
	| IBoxRadioListComponent
	| IBoxChooserComponent
	| IBoxSelectComponent
> =>
	field.type === BoxComponentType.CHECKBOXLIST ||
	field.type === BoxComponentType.RADIOLIST ||
	field.type === BoxComponentType.CHOOSER ||
	field.type === BoxComponentType.SELECT;

export const isBoxComponentInput = (
	field: IBoxComponent,
): field is IBoxComponent<IBoxInputComponent> =>
	field.type === BoxComponentType.INPUT;

export const isSubmitComponent = (
	field: IBoxComponent,
): field is IBoxComponent<IBoxSubmitComponent> =>
	field.type === BoxComponentType.SUBMIT;
